import { render } from "./CreateProducts.vue?vue&type=template&id=726a3cab&ts=true"
import script from "./CreateProducts.ts?vue&type=script&lang=ts&external"
export * from "./CreateProducts.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__